import {ConnectSSOAccountPanel} from '@Panels/connect-sso-account-panel/connect-sso-account-panel';

export default ConnectSSOAccountPanel;
export * from './connect-sso-account-panel';
